module.exports = __webpack_public_path__ + "static/projekt_indywidualny_b4-876acaafd722d0ba48cb46293ba3cd39.jpg";